import Pwa from "./Pwa";

export default {
    install(Vue) {
        // Make PWA and its properties reactive.
        let app = new Vue({
            data: {
                pwa: new Pwa()
            }
        });
        Vue.prototype.$pwa = app.pwa;
    }
}
  